import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { RequestService, Request } from '../services/request.service';
import { ProjectService, Project} from '../services/project.service';
import { FileEntry } from '../services/request.service';
import { forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SelectedProjectService } from '../services/selectedproject.service';
import { MatIcon } from '@angular/material/icon';
import { AuthService } from '../services/auth.service';
import { UserService } from '../services/user.service';
import { RequestEmailModalComponent } from '../request-email-modal/request-email-modal.component';
import { RequestEmailResponse } from '../models/request-email.models';

@Component({
  selector: 'app-request',
  imports: [CommonModule, FormsModule, MatIcon, RequestEmailModalComponent],
  templateUrl: './request.component.html',
  styleUrl: './request.component.css'
})
export class RequestComponent implements OnInit {
  private readonly requestFilterStateKey = 'request-page-filter-state';
    private pendingRequestId: string | null = null;
    private pendingDescription: string | null = null;
    projectNumber: number | null = null;
    searchedProjectNumber: number | null = null;
  allRequests: Request[] = [];
    requests: Request[] = [];
    error: string | null = null;
    projectName: string | null = null;
    loading = false;
  searchQuery = '';
  showAdvancedFilters = false;
  metadataIndexedCount = 0;
  metadataTotalCount = 0;
    selectedFiles: Array<FileEntry & { displayName?: string; source: string }> = [];
    fileSortOrder: 'desc' | 'asc' = 'desc';
    fileCountMap: { [requestGuid: string]: number } = {};
    hasFilesMap: { [requestGuid: string]: boolean } = {};
    revisionCountMap: { [requestGuid: string]: number } = {};
  awaitingResponseMap: { [requestGuid: string]: boolean } = {};
  hasAnyResponseMap: { [requestGuid: string]: boolean } = {};
  requestSearchIndexMap: { [requestGuid: string]: string } = {};
  requestAttachmentKindsMap: { [requestGuid: string]: string[] } = {};

    // UI state for inline cards
    expandedRequests: { [requestGuid: string]: boolean } = {};
    revisionsMap: { [requestGuid: string]: any[] } = {};
    loadingRevisions: { [requestGuid: string]: boolean } = {};
    // Per-revision UI state
    revisionExpanded: { [revisionGuid: string]: boolean } = {};
    revisionLoadingMap: { [revisionGuid: string]: boolean } = {};
    // File maps for revisions and responses
    revisionFilesMap: { [revisionGuid: string]: FileEntry[] } = {};
    responseFilesMap: { [responseGuid: string]: FileEntry[] } = {};
    revisionFilesLoading: { [revisionGuid: string]: boolean } = {};
    responseFilesLoading: { [responseGuid: string]: boolean } = {};
    selectedFile: File | null = null;
    selectedRequestNumber: string | null = null;
    selectedRequestDescription: string | null = null;
    activeRequestType: string | null = null;
    uploadError: string | null = null;
    uploadSuccess: string | null = null;
    uploadInProgress = false;
    activeRequestId: string | null = null;
    modalRevisions: any[] = [];
    modalResponses: any[] = [];
    modalRevisionsWithFiles: any[] = [];
    modalResponsesWithFiles: any[] = [];
    modalRevisionExpanded: { [revisionGuid: string]: boolean } = {};
    pdfPreviewOpen = false;
    pdfPreviewLoading = false;
    pdfPreviewError: string | null = null;
    pdfPreviewTitle: string | null = null;
    pdfPreviewPageCount: number | null = null;
    pdfPreviewUrl: SafeResourceUrl | null = null;
    pdfPreviewBlobUrl: string | null = null;
    pdfPreviewFileId: string | null = null;
    pdfPreviewFileName: string | null = null;
    previewFileType: 'pdf' | 'image' | null = null;
    pdfObjectLoadFailed = false;
    fileActionInProgress = false;
    fileActionError: string | null = null;
    activeEmailRequest: Request | null = null;
    emailActionMessage: string | null = null;

    updateSuccess: boolean = false;
    updateSuccessMessage: string = '';
    updatingStatus: { [requestGuid: string]: boolean } = {};
    updatingStage: { [requestGuid: string]: boolean } = {};
    updatingPriority: { [requestGuid: string]: boolean } = {};

    projects: Project[] = [];
    projectsLoading = false;

    limitedToIq = false;

    userCache = new Map<string, string>();

    sortColumn: 'number' | 'date' | 'files' | 'status' | 'stage' | 'priority' | 'revisions' | 'project' = 'number';
    sortDirection: 'asc' | 'desc' = 'asc';
  // 0 = inactive, 1-4 = Action Required / Acknowledged / In Progress / Complete
  stageSortStep = 0;
  // 0 = inactive, 1 = Open, 2 = Answered, 3 = Closed
  statusSortStep = 0;
  // 0 = inactive, 1 = High, 2 = Medium, 3 = Low
  prioritySortStep = 0;
  // 0 = inactive, 1..N = cycle through each unique project number
  projectSortStep = 0;
  sortableProjectNumbers: number[] = [];

    private projectColors = new Map<number, string>();
    private readonly palette = [
      '#e8eaf6', '#f3e5f5', '#e0f7fa', '#fbe9e7', '#ede7f6',
      '#e0f2f1', '#f5eef8', '#fdf2e9', '#eaf2f8', '#fae5d3',
      '#d5d8dc', '#d6eaf8', '#e8daef', '#d1f2eb', '#f6ddcc'
    ];
    private readonly paletteDark = [
      '#283593', '#6a1b9a', '#00838f', '#bf360c', '#4527a0',
      '#00695c', '#6c3483', '#ba4a00', '#1a5276', '#a04000',
      '#566573', '#2471a3', '#7d3c98', '#148f77', '#af601a'
    ];

    getProjectColor(projectNumber: number): string {
      if (!this.projectColors.has(projectNumber)) {
        const idx = this.projectColors.size % this.palette.length;
        this.projectColors.set(projectNumber, this.palette[idx]);
      }
      return this.projectColors.get(projectNumber)!;
    }

    getProjectTextColor(projectNumber: number): string {
      if (!this.projectColors.has(projectNumber)) {
        this.getProjectColor(projectNumber);
      }
      const bg = this.projectColors.get(projectNumber)!;
      const idx = this.palette.indexOf(bg);
      return this.paletteDark[idx] || '#333';
    }

    filters = {
      rfi: true,
      cdq: true,
      crfi: true,
    iq: true,
    risk: true,
      status: 'all',
      stage: 'all',
      requestType: 'all',
      hasAttachments: false,
      awaitingResponse: false,
      dateFrom: '',
      dateTo: ''
    };

    constructor(
       private requestService: RequestService,
       private projectService: ProjectService,
       private selectedProjectService: SelectedProjectService,
       private authService: AuthService,
       private userService: UserService,
       private sanitizer: DomSanitizer,
       private route: ActivatedRoute) {}

    ngOnInit() {
      this.limitedToIq = this.authService.hasAnyRole(['Offshore','OutSourceAdmin','OutsourcePM','OutsourceUser']);

      // All roles can see all request types
      this.restoreSavedFilters();

      this.loadProjects();

      // Check for deep-link query params from home page activity click
      const params = this.route.snapshot.queryParams;

      // Apply status filter from query param (e.g. ?status=Closed)
      if (params['status']) {
        this.filters.status = params['status'];
      }

      // Apply stage filter from query param (e.g. ?stage=Action Required)
      if (params['stage']) {
        this.filters.stage = params['stage'];
      }

      if (params['project']) {
        const proj = Number(params['project']);
        if (!isNaN(proj)) {
          this.projectNumber = proj;
          this.selectedProjectService.setSelectedProject(proj);
          this.pendingRequestId = params['requestId'] || null;
          this.pendingDescription = params['description'] || null;
          // Enable all type filters so the target request is included in the API response
          this.filters = { ...this.filters, rfi: true, cdq: true, crfi: true, iq: true, risk: true };
          this.fetchRequests();
          return;
        }
      }

      const selectedProject = this.selectedProjectService.getSelectedProject();
      if (selectedProject) {
        this.projectNumber = selectedProject;
      }
      this.fetchRequests();
    }

    loadProjects(): void {
    this.projectsLoading = true;
    this.projectService.getAllProjects().subscribe({
      next: (projects) => {
        this.projects = projects;
        this.projectsLoading = false;
      },
      error: (err) => {
        this.error = 'Failed to load projects';
        this.projectsLoading = false;
        console.error(err);
      }
    });
  }

  restoreSavedFilters() {
    try {
      const savedFilters = localStorage.getItem(this.requestFilterStateKey);
      if (!savedFilters) {
        return;
      }

      const parsed = JSON.parse(savedFilters) as Partial<typeof this.filters>;
      this.filters = {
        rfi: parsed.rfi ?? true,
        cdq: parsed.cdq ?? true,
        crfi: parsed.crfi ?? true,
        iq: parsed.iq ?? true,
        risk: parsed.risk ?? true,
        status: parsed.status ?? 'all',
        stage: parsed.stage ?? 'all',
        requestType: parsed.requestType ?? 'all',
        hasAttachments: parsed.hasAttachments ?? false,
        awaitingResponse: parsed.awaitingResponse ?? false,
        dateFrom: parsed.dateFrom ?? '',
        dateTo: parsed.dateTo ?? ''
      };
    } catch {
      this.filters = {
        rfi: true,
        cdq: true,
        crfi: true,
        iq: true,
        risk: true,
        status: 'all',
        stage: 'all',
        requestType: 'all',
        hasAttachments: false,
        awaitingResponse: false,
        dateFrom: '',
        dateTo: ''
      };
    }
  }

  onProjectSelectionChange(projectNumber: number | null) {
    this.projectNumber = projectNumber;

    if (projectNumber === null) {
      this.selectedProjectService.clearSelectedProject();
    } else {
      this.selectedProjectService.setSelectedProject(projectNumber);
    }

    this.fetchRequests();
  }

  saveFilters() {
    localStorage.setItem(this.requestFilterStateKey, JSON.stringify(this.filters));
  }

  private autoExpandPendingRequest(): void {
    if (!this.pendingRequestId && !this.pendingDescription) return;

    // Search allRequests (unfiltered) so client-side filters can't hide the target
    let match: Request | undefined;

    if (this.pendingRequestId) {
      match = this.allRequests.find(r => r.requestGuid.toString() === this.pendingRequestId);
    }
    if (!match && this.pendingDescription) {
      const desc = this.pendingDescription.toLowerCase();
      // Try exact match first, then substring match
      match = this.allRequests.find(r => r.description?.toLowerCase() === desc)
           || this.allRequests.find(r => desc.includes(r.description?.toLowerCase()))
           || this.allRequests.find(r => r.description?.toLowerCase().includes(desc));
    }

    // Clear pending so it doesn't re-trigger
    this.pendingRequestId = null;
    this.pendingDescription = null;

    if (match) {
      const guid = match.requestGuid.toString();
      this.expandedRequests[guid] = true;
      if (!this.revisionsMap[guid]) {
        this.fetchRevisionsForRequest(guid);
      }
      // Scroll to the card after DOM renders
      setTimeout(() => {
        const el = document.getElementById('request-card-' + guid);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 200);
    }
  }

  toggleRequestCard(rfi: Request, cardEl?: HTMLElement) {
    const guid = rfi.requestGuid.toString();
    const isOpen = !!this.expandedRequests[guid];
    if (isOpen) {
      this.expandedRequests[guid] = false;
      return;
    }

    // open - fetch revisions if needed
    this.expandedRequests[guid] = true;

    // smooth scroll the card into view so user doesn't have to scroll to bottom
    if (cardEl && cardEl.scrollIntoView) {
      // delay slightly to allow DOM to render expanded area
      setTimeout(() => {
        try { cardEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch { /* ignore */ }
      }, 80);
    }

    if (!this.revisionsMap[guid]) {
      this.fetchRevisionsForRequest(guid);
    }
  }

  fetchRevisionsForRequest(requestGuid: string | number) {
    const key = requestGuid == null ? '' : requestGuid.toString();
    this.loadingRevisions[key] = true;
    // Ask the backend to include responses so badge state is correct on load
    this.requestService.getRevisionsByRequest(key, true).subscribe({
      next: (revs) => {
        // ensure consistent structure: each revision may include `responses`
        this.revisionsMap[key] = revs.map(r => ({
          ...r,
          responses: (r as any).responses || []
        }));
        // resolve usernames for revision creators and responders
        this.resolveUsernames(this.revisionsMap[key]);
        // if backend didn't return responses, try to fetch per-revision lazily when expanded
        this.loadingRevisions[key] = false;
      },
      error: (err) => {
        console.error('Failed to load revisions for', key, err);
        this.revisionsMap[key] = [];
        this.loadingRevisions[key] = false;
      }
    });
  }

  // Toggle a specific revision to show/hide responses. If responses are not present
  // attempt to fetch them lazily from the backend.
  toggleRevision(revision: any, requestGuid: string | number) {
    if (!revision) return;
    const revGuid = revision.revisionGuid ? revision.revisionGuid.toString() : '';
    const isOpen = !!this.revisionExpanded[revGuid];
    if (isOpen) {
      this.revisionExpanded[revGuid] = false;
      return;
    }

    // open
    this.revisionExpanded[revGuid] = true;

    // Fetch revision files if not loaded yet
    if (!this.revisionFilesMap[revGuid] && !this.revisionFilesLoading[revGuid]) {
      this.revisionFilesLoading[revGuid] = true;
      this.requestService.getFilesByRevision(revGuid).subscribe({
        next: (files) => {
          this.revisionFilesMap[revGuid] = files;
          this.revisionFilesLoading[revGuid] = false;
        },
        error: () => {
          this.revisionFilesMap[revGuid] = [];
          this.revisionFilesLoading[revGuid] = false;
        }
      });
    }

    // If no responses are present, fetch them
    if ((!revision.responses || revision.responses.length === 0) && !this.revisionLoadingMap[revGuid]) {
      this.revisionLoadingMap[revGuid] = true;
      this.requestService.getResponsesByRevision(revGuid).subscribe({
        next: (res) => {
          try { revision.responses = res || []; } catch { revision.responses = []; }
          this.resolveUsernames([revision]);
          // Fetch files for each response
          for (const resp of revision.responses) {
            this.fetchResponseFiles(revGuid, resp);
          }
          this.revisionLoadingMap[revGuid] = false;
        },
        error: (err) => {
          console.error('Failed to load responses for revision', revGuid, err);
          revision.responses = [];
          this.revisionLoadingMap[revGuid] = false;
        }
      });
    } else if (revision.responses && revision.responses.length > 0) {
      // Responses already loaded, fetch files for them if not already loaded
      for (const resp of revision.responses) {
        this.fetchResponseFiles(revGuid, resp);
      }
    }
  }

  fetchResponseFiles(revisionGuid: string, resp: any) {
    const respGuid = resp.responseGuid ? resp.responseGuid.toString() : '';
    if (!respGuid || this.responseFilesMap[respGuid] || this.responseFilesLoading[respGuid]) return;
    this.responseFilesLoading[respGuid] = true;
    this.requestService.getFilesByResponse(revisionGuid, respGuid).subscribe({
      next: (files) => {
        this.responseFilesMap[respGuid] = files;
        this.responseFilesLoading[respGuid] = false;
      },
      error: () => {
        this.responseFilesMap[respGuid] = [];
        this.responseFilesLoading[respGuid] = false;
      }
    });
  }

  getFileDownloadUrl(fileId: string): string {
    return this.requestService.getFileDownloadUrl(fileId);
  }

  getDisplayFileName(fileName: string): string {
    return this.stripGuidFromFilename(fileName);
  }

  isImageFile(file: Pick<FileEntry, 'fileName'> | null | undefined): boolean {
    const fileName = file?.fileName;
    if (typeof fileName !== 'string') {
      return false;
    }

    return /\.(png|jpe?g|gif|bmp|webp|svg)$/i.test(fileName);
  }

  isPreviewableFile(file: Pick<FileEntry, 'fileName'> | null | undefined): boolean {
    return this.isPdfFile(file) || this.isImageFile(file);
  }

  getFileType(fileName: string | null | undefined): string {
    const normalized = (fileName || '').toLowerCase();

    if (normalized.endsWith('.pdf')) return 'pdf';
    if (/\.(png|jpe?g|gif|bmp|webp|svg)$/i.test(normalized)) return 'image';
    if (/\.(xlsx|xls|csv)$/i.test(normalized)) return 'sheet';
    if (/\.(dwg|dxf|rvt|ifc)$/i.test(normalized)) return 'drawing';
    if (/\.(doc|docx|txt|rtf)$/i.test(normalized)) return 'doc';
    if (/\.(zip|rar|7z)$/i.test(normalized)) return 'archive';
    return 'other';
  }

  getFileTypeLabel(fileName: string | null | undefined): string {
    const fileType = this.getFileType(fileName);
    const labels: Record<string, string> = {
      pdf: 'PDF',
      image: 'Image',
      sheet: 'Sheet',
      drawing: 'Drawing',
      doc: 'Doc',
      archive: 'Archive',
      other: 'File'
    };

    return labels[fileType] || 'File';
  }

  getFileTypeIcon(fileName: string | null | undefined): string {
    const fileType = this.getFileType(fileName);
    const icons: Record<string, string> = {
      pdf: 'picture_as_pdf',
      image: 'image',
      sheet: 'table_chart',
      drawing: 'architecture',
      doc: 'description',
      archive: 'folder_zip',
      other: 'insert_drive_file'
    };

    return icons[fileType] || 'insert_drive_file';
  }

  getRequestAttachmentKinds(requestGuid: string | number): string[] {
    const key = requestGuid == null ? '' : requestGuid.toString();
    return this.requestAttachmentKindsMap[key] || [];
  }

  isPdfFile(file: Pick<FileEntry, 'fileName'> | null | undefined): boolean {
    const fileName = file?.fileName;
    return typeof fileName === 'string' && fileName.toLowerCase().endsWith('.pdf');
  }

  openFile(file: FileEntry & { displayName?: string }, event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();

    if (this.isPreviewableFile(file)) {
      this.openPdfPreview(file);
      return;
    }

    this.downloadFile(file);
  }

  openPdfPreview(file: FileEntry & { displayName?: string }) {
    if (!file?.fileId) {
      return;
    }

    this.closePdfPreview(false);
    this.pdfPreviewOpen = true;
    this.pdfPreviewLoading = true;
    this.pdfPreviewError = null;
    this.pdfPreviewPageCount = null;
    this.pdfPreviewTitle = file.displayName || this.getDisplayFileName(file.fileName);
    this.pdfPreviewFileId = file.fileId;
    this.pdfPreviewFileName = this.pdfPreviewTitle;
    this.previewFileType = this.isImageFile(file) ? 'image' : 'pdf';
    this.pdfObjectLoadFailed = false;

    this.requestService.downloadFile(file.fileId).subscribe({
      next: async (blob) => {
        // If the server returned a generic MIME type for a PDF file, re-create blob with correct type
        let effectiveBlob = blob;
        if (this.isPdfFile(file) && blob.type && !blob.type.toLowerCase().includes('pdf')) {
          effectiveBlob = new Blob([blob], { type: 'application/pdf' });
        }

        const blobUrl = URL.createObjectURL(effectiveBlob);
        this.pdfPreviewBlobUrl = blobUrl;
        this.pdfPreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);

        try {
          if (this.isPdfFile(file)) {
            this.pdfPreviewPageCount = await this.getPdfPageCount(effectiveBlob);
          }
        } catch {
          this.pdfPreviewError = 'The PDF was downloaded, but page details could not be read. You can still download the file.';
        }

        this.pdfPreviewLoading = false;
      },
      error: () => {
        this.pdfPreviewLoading = false;
        this.pdfPreviewError = 'This PDF could not be loaded in the app. You can try downloading it instead.';
      }
    });
  }

  closePdfPreview(clearOpenState: boolean = true) {
    if (this.pdfPreviewBlobUrl) {
      URL.revokeObjectURL(this.pdfPreviewBlobUrl);
    }

    this.pdfPreviewBlobUrl = null;
    this.pdfPreviewUrl = null;
    this.pdfPreviewPageCount = null;
    this.pdfPreviewError = null;
    this.pdfPreviewTitle = null;
    this.pdfPreviewFileId = null;
    this.pdfPreviewFileName = null;
    this.previewFileType = null;
    this.pdfPreviewLoading = false;
    this.pdfObjectLoadFailed = false;
    this.fileActionError = null;

    if (clearOpenState) {
      this.pdfPreviewOpen = false;
    }
  }

  markPdfObjectLoadFailed() {
    this.pdfObjectLoadFailed = true;
  }

  downloadCurrentPreviewFile() {
    if (!this.pdfPreviewFileId || !this.pdfPreviewFileName) {
      return;
    }

    this.downloadFileById(this.pdfPreviewFileId, this.pdfPreviewFileName);
  }

  downloadFile(file: Pick<FileEntry, 'fileId' | 'fileName'> & { displayName?: string }) {
    if (!file?.fileId) {
      return;
    }

    const downloadName = file.displayName || this.getDisplayFileName(file.fileName as string);
    this.downloadFileById(file.fileId, downloadName);
  }

  downloadFileById(fileId: string, downloadName: string) {
    if (!fileId) {
      return;
    }

    this.fileActionInProgress = true;
    this.fileActionError = null;

    this.requestService.downloadFile(fileId)
      .pipe(finalize(() => {
        this.fileActionInProgress = false;
      }))
      .subscribe({
        next: (blob) => {
          const objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = objectUrl;
          link.download = downloadName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(objectUrl);
        },
        error: () => {
          this.fileActionError = 'The file could not be downloaded right now.';
        }
      });
  }

  async getPdfPageCount(blob: Blob): Promise<number | null> {
    if (typeof window === 'undefined') {
      return null;
    }

    const pdfjs = await import('pdfjs-dist');
    pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';
    const pdf = await pdfjs.getDocument({ data: await blob.arrayBuffer() }).promise;

    try {
      return pdf.numPages;
    } finally {
      await pdf.destroy();
    }
  }

  resolveUsernames(revisions: any[]) {
    const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    const ids = new Set<string>();
    for (const rev of revisions) {
      if (rev.createdBy) ids.add(rev.createdBy);
      for (const resp of rev.responses || []) {
        if (resp.responder) ids.add(resp.responder);
      }
    }
    for (const id of ids) {
      if (this.userCache.has(id)) continue;
      // Only call the API for GUID-format IDs; treat anything else as an already-resolved name
      if (!guidPattern.test(id)) {
        this.userCache.set(id, id);
        continue;
      }
      this.userService.getUserById(id).subscribe({
        next: (user) => {
          const fullName = [user.firstname, user.lastname].filter(Boolean).join(' ') || id;
          this.userCache.set(id, fullName);
        },
        error: () => {
          // Fallback to username endpoint (accessible to all roles)
          this.userService.getUsernameById(id).subscribe({
            next: (username) => this.userCache.set(id, username || id),
            error: () => this.userCache.set(id, id)
          });
        }
      });
    }
  }

  getResponseCount(requestGuid: string | number): number | null {
    const key = requestGuid == null ? '' : requestGuid.toString();
    const revs = this.revisionsMap[key];
    if (!revs) return null;
    try {
      return revs.reduce((acc, r) => acc + ((r.responses && r.responses.length) || 0), 0);
    } catch {
      return null;
    }
  }

  // Modal for viewing a single response
  selectedResponse: any = null;
  // Modal for viewing a single revision
  selectedRevision: any = null;
  showFilesModal: boolean = false;

  openResponseModal(response: any) {
    this.selectedResponse = response || null;
  }

  closeModal() {
    this.selectedResponse = null;
  }

  openRevisionModal(revision: any) {
    this.selectedRevision = revision || null;
  }

  closeRevisionModal() {
    this.selectedRevision = null;
  }

  onSearchChange() {
    this.applyClientFilters();
  }

  onAdvancedFiltersChange() {
    this.showAdvancedFilters = this.hasActiveAdvancedFilters();
    this.applyClientFilters();
  }

  toggleAdvancedFilters() {
    this.showAdvancedFilters = !this.showAdvancedFilters;
  }

  hasActiveAdvancedFilters(): boolean {
    return this.filters.status !== 'all'
      || this.filters.stage !== 'all'
      || this.filters.requestType !== 'all'
      || this.filters.hasAttachments
      || this.filters.awaitingResponse
      || !!this.filters.dateFrom
      || !!this.filters.dateTo;
  }

  clearAdvancedFilters() {
    this.searchQuery = '';
    this.filters = {
      ...this.filters,
      status: 'all',
      stage: 'all',
      requestType: 'all',
      hasAttachments: false,
      awaitingResponse: false,
      dateFrom: '',
      dateTo: ''
    };
    this.showAdvancedFilters = false;
    this.applyClientFilters();
  }

  getAvailableRequestTypes(): string[] {
    return Array.from(new Set(this.allRequests.map((request) => request.requestType).filter(Boolean))).sort();
  }

  getActiveAdvancedFilterCount(): number {
    let count = 0;
    if (this.searchQuery.trim()) count += 1;
    if (this.filters.status !== 'all') count += 1;
    if (this.filters.stage !== 'all') count += 1;
    if (this.filters.requestType !== 'all') count += 1;
    if (this.filters.hasAttachments) count += 1;
    if (this.filters.awaitingResponse) count += 1;
    if (this.filters.dateFrom) count += 1;
    if (this.filters.dateTo) count += 1;
    return count;
  }

  getFilterSummary(): string {
    if (!this.allRequests.length) {
      return '';
    }

    return `${this.requests.length} of ${this.allRequests.length} requests shown`;
  }

  buildBaseSearchIndex(request: Request): string {
    return [request.number, request.description, request.status, this.getStageDisplay(request.stage), request.requestType, request.priority]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
  }

  buildSearchIndex(request: Request, revisions: any[], files: FileEntry[]): string {
    const revisionText = revisions.flatMap((revision) => {
      const responses = (revision.responses || []).flatMap((response: any) => [response.responseText, response.responder, response.dateCreated]);
      return [revision.questionText, revision.createdBy, revision.dateCreated, ...responses];
    });
    const fileText = files.flatMap((file) => [file.fileName, this.getDisplayFileName(file.fileName), file.type, file.uploadedBy]);

    return [this.buildBaseSearchIndex(request), ...revisionText, ...fileText]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
  }

  normalizeRevisions(revisions: any[]): any[] {
    return (revisions || []).map((revision) => ({
      ...revision,
      responses: (revision.responses || []).map((response: any) => ({ ...response }))
    }));
  }

  updateRequestMetadata(request: Request, files: FileEntry[], revisions: any[]) {
    const guid = request.requestGuid.toString();
    const normalizedRevisions = this.normalizeRevisions(revisions);
    this.revisionsMap[guid] = normalizedRevisions;
    this.fileCountMap[guid] = files.length;
    this.hasFilesMap[guid] = files.length > 0;
    this.revisionCountMap[guid] = normalizedRevisions.length;
    this.awaitingResponseMap[guid] = normalizedRevisions.some((revision) => !revision.responses || revision.responses.length === 0);
    this.hasAnyResponseMap[guid] = normalizedRevisions.some((revision) => revision.responses && revision.responses.length > 0);
    this.requestSearchIndexMap[guid] = this.buildSearchIndex(request, normalizedRevisions, files);
    this.requestAttachmentKindsMap[guid] = Array.from(new Set(files.map((file) => this.getFileType(file.fileName))));
    this.resolveUsernames(normalizedRevisions);
  }

  preloadRequestMetadata() {
    this.metadataIndexedCount = 0;
    this.metadataTotalCount = this.allRequests.length;

    for (const request of this.allRequests) {
      const guid = request.requestGuid.toString();
      this.requestSearchIndexMap[guid] = this.buildBaseSearchIndex(request);

      forkJoin({
        files: this.requestService.getFilesByRequest(guid),
        revisions: this.requestService.getRevisionsByRequest(guid, true)
      }).subscribe({
        next: ({ files, revisions }) => {
          this.updateRequestMetadata(request, files, revisions);
          this.metadataIndexedCount += 1;
          this.applyClientFilters();
        },
        error: () => {
          this.fileCountMap[guid] = 0;
          this.hasFilesMap[guid] = false;
          this.revisionCountMap[guid] = 0;
          this.awaitingResponseMap[guid] = false;
          this.hasAnyResponseMap[guid] = false;
          this.requestAttachmentKindsMap[guid] = [];
          this.metadataIndexedCount += 1;
          this.applyClientFilters();
        }
      });
    }
  }

  applyClientFilters() {
    const query = this.searchQuery.trim().toLowerCase();
    const fromDate = this.filters.dateFrom ? new Date(`${this.filters.dateFrom}T00:00:00`) : null;
    const toDate = this.filters.dateTo ? new Date(`${this.filters.dateTo}T23:59:59`) : null;

    this.requests = this.allRequests.filter((request) => {
      const guid = request.requestGuid.toString();
      const searchIndex = this.requestSearchIndexMap[guid] || this.buildBaseSearchIndex(request);
      const createdDate = request.createdDate ? new Date(request.createdDate) : null;

      if (query && !searchIndex.includes(query)) {
        return false;
      }

      if (this.filters.status !== 'all' && request.status !== this.filters.status) {
        return false;
      }

      if (this.filters.stage !== 'all') {
        if (this.filters.stage === 'Action Required') {
          // Only match Answered requests with no stage set (actual Action Required)
          const isAnsweredNoStage = request.status === 'Answered' && !request.stage;
          if (!isAnsweredNoStage) {
            return false;
          }
        } else if (this.getStageDisplay(request.stage) !== this.filters.stage) {
          return false;
        }
      }

      if (this.filters.requestType !== 'all' && request.requestType !== this.filters.requestType) {
        return false;
      }

      if (this.filters.hasAttachments && !this.hasFilesMap[guid]) {
        return false;
      }

      if (this.filters.awaitingResponse && !this.awaitingResponseMap[guid]) {
        return false;
      }

      if (fromDate && (!createdDate || createdDate < fromDate)) {
        return false;
      }

      if (toDate && (!createdDate || createdDate > toDate)) {
        return false;
      }

      return true;
    });

    this.sortRequests();

    if (!this.loading) {
      this.error = this.requests.length === 0 ? 'No requests match the current search and filters.' : null;
    }
  }
  
    fetchRequests() {
      this.selectedFiles = [];
      this.activeRequestId = null;
  
      this.loading = true;
      this.error = null;

      this.searchedProjectNumber = this.projectNumber;

      const request$ = this.projectNumber !== null
        ? this.requestService.getRequestsByProject(this.projectNumber, this.filters)
        : this.requestService.getAllRequests(this.filters);

      request$.subscribe({
        next: (data) => {
          // Default priority to 'Medium' for any record missing it
          data.forEach(r => { if (!r.priority) r.priority = 'Medium'; });
          this.allRequests = data;
          this.requests = [...data];
          this.sortColumn = this.projectNumber === null ? 'project' : 'number';
          this.sortDirection = 'asc';
          this.projectSortStep = 0;
          // Build sorted list of unique project numbers from the data
          this.sortableProjectNumbers = Array.from(new Set(data.map(r => r.projectNumber))).sort((a, b) => a - b);
          this.applyClientFilters();
          this.preloadRequestMetadata();
          this.loading = false;
  
          if (this.allRequests.length === 0) {
            this.error = 'No requests found for this project number and filter.';
          } else {
            this.error = null;
          }

          // Auto-expand a request if navigated from home activity
          this.autoExpandPendingRequest();

          if (this.projectNumber !== null) {
            this.projectService.getProjectByNumber(this.projectNumber!).subscribe({
              next: (projectData) => {
                this.projectName = projectData.projectName;
              },
              error: (err) => {
                this.error = typeof err.error === 'string' ? err.error : 'Error fetching project name.';
                this.projectName = null;
              },
            });
          } else {
            this.projectName = null;
          }

        },
        error: (err) => {
          this.error = typeof err.error === 'string' ? err.error : (err.status === 403 ? 'You do not have permission to view requests.' : 'Error fetching requests.');
          this.requests = [];
          this.allRequests = [];
          this.loading = false;
        },
      });
    }

showFilesForRequest(rfi: Request, cardEl?: HTMLElement) {
  this.activeRequestId = rfi.requestGuid.toString();
  this.selectedRequestNumber = rfi.number;
  this.selectedRequestDescription = (rfi as any).description || null;
  this.activeRequestType = rfi.requestType;

  if (cardEl && cardEl.scrollIntoView) {
    setTimeout(() => {
      try { cardEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch { }
    }, 60);
  }

  const guid = rfi.requestGuid.toString();

  forkJoin({
    files: this.requestService.getFilesByRequest(guid),
    revisions: this.requestService.getRevisionsByRequest(guid, true)
  }).subscribe({
    next: ({ files, revisions }) => {
      this.selectedFiles = files.map(f => ({
        ...f,
        displayName: this.stripGuidFromFilename(f.fileName),
        source: this.getFileSource(f, revisions)
      }));
      this.fileCountMap[this.activeRequestId!] = files.length;
      this.sortSelectedFiles();

      this.modalRevisions = revisions.map(rev => ({
        ...rev,
        files: files
          .filter(f => f.type === 'Revision' && f.uploadedForId === rev.revisionGuid)
          .map(f => ({ ...f, displayName: this.stripGuidFromFilename(f.fileName) })),
        responses: (rev.responses || []).map((resp: any, idx: number) => ({
          ...resp,
          responseNumber: idx + 1,
          files: files
            .filter(f => f.type === 'Response' && f.uploadedForId === resp.responseGuid)
            .map(f => ({ ...f, displayName: this.stripGuidFromFilename(f.fileName) }))
        }))
      }));

      const allResponses: any[] = [];
      for (const rev of this.modalRevisions) {
        for (const resp of (rev.responses || [])) {
          allResponses.push(resp);
        }
      }
      this.modalResponses = allResponses;
      this.modalRevisionsWithFiles = this.modalRevisions.filter(r => r.files && r.files.length > 0);
      this.modalResponsesWithFiles = this.modalResponses.filter(r => r.files && r.files.length > 0);

      this.resolveUsernames(revisions);
      this.showFilesModal = true;
    },
    error: (err) => {
      console.error(err);
      this.selectedFiles = [];
      this.modalRevisions = [];
      this.modalResponses = [];
    }
  });
}

closeFilesModal() {
  this.showFilesModal = false;
  this.modalRevisionExpanded = {};
}

toggleModalRevision(revisionGuid: string) {
  this.modalRevisionExpanded[revisionGuid] = !this.modalRevisionExpanded[revisionGuid];
}

stripGuidFromFilename(filename: string): string {
  if (!filename) return filename;
  // Remove a leading GUID (36 chars including hyphens) and an optional separator (underscore or dash)
  return filename.replace(/^[0-9a-fA-F-]{36}[_-]?/, '');
}

getFileSource(file: FileEntry, revisions: any[]): string {
  const fileType = (file.type || '').toLowerCase();

  if (fileType === 'request') {
    return 'Request';
  }

  const revisionIndex = revisions.findIndex(
    revision => revision.revisionGuid?.toString() === file.uploadedForId?.toString()
  );
  if (fileType === 'revision' && revisionIndex !== -1) {
    const revision = revisions[revisionIndex];
    return `Revision ${revision.revisionNumber ?? (revisionIndex + 1)}`;
  }

  if (fileType === 'response') {
    for (let revisionIndex = 0; revisionIndex < revisions.length; revisionIndex++) {
      const revision = revisions[revisionIndex];
      const responseIndex = (revision.responses || []).findIndex(
        (response: any) => response.responseGuid?.toString() === file.uploadedForId?.toString()
      );

      if (responseIndex !== -1) {
        const revisionNumber = revision.revisionNumber ?? (revisionIndex + 1);
        return `Revision ${revisionNumber} Response ${responseIndex + 1}`;
      }
    }
  }

  return file.type || 'Request';
}

setFileSortOrder(order: 'desc' | 'asc' | string) {
  this.fileSortOrder = order === 'asc' ? 'asc' : 'desc';
  this.sortSelectedFiles();
}

sortSelectedFiles() {
  if (!this.selectedFiles) return;
  this.selectedFiles.sort((a, b) => {
    const da = a.createdDate ? new Date(a.createdDate).getTime() : 0;
    const db = b.createdDate ? new Date(b.createdDate).getTime() : 0;
    return this.fileSortOrder === 'asc' ? da - db : db - da;
  });
}

onFileSelected(event: any) {
  const element = event.target as HTMLInputElement;
  if (element.files && element.files.length > 0) {
    this.selectedFile = element.files[0];
    this.uploadError = null;
    this.uploadSuccess = null;
  }
}

uploadAdditionalFile(): void {
  if (!this.selectedFile || !this.activeRequestId) {
      return;
    }

    if (this.limitedToIq && this.activeRequestType !== 'IQ') {
      this.uploadError = 'You can only upload files to IQ requests with your role.';
      return;
    }
    
    this.uploadInProgress = true;
    this.uploadError = null;
    this.uploadSuccess = null;
    
    this.requestService.uploadFile(this.activeRequestId, this.selectedFile, localStorage.getItem('id') || '')
      .pipe(finalize(() => {
        this.uploadInProgress = false;
      }))
      .subscribe({
        next: () => {
          this.uploadSuccess = 'File uploaded successfully';
          this.selectedFile = null;
          
          // Refresh the files list
          this.showFilesForRequest({ requestGuid: this.activeRequestId! } as unknown as Request);
        },
        error: (err) => {
          console.error('File upload failed:', err);
          this.uploadError = 'Failed to upload file. Please try again.';
        }
      });
}

canEditRfiStatus(): boolean {
    return !this.authService.isReadOnly() && this.authService.hasAnyRole(['Admin', 'PM']);
}

canEmailRequests(): boolean {
    return this.authService.hasRole('Email');
}

isOpenRequest(request: Request): boolean {
    return request.status?.trim().toLowerCase() === 'open';
}

getCurrentUserEmail(): string | null {
    return this.authService.getSession()?.user.email?.trim() || null;
}

openRequestEmailModal(request: Request): void {
    this.emailActionMessage = null;

    if (!this.canEmailRequests() || !this.isOpenRequest(request)) {
      return;
    }

    if (!this.getCurrentUserEmail()) {
      this.emailActionMessage =
        'An email address must be attached to your account before sending request emails.';
      return;
    }

    this.activeEmailRequest = request;
}

closeRequestEmailModal(): void {
    this.activeEmailRequest = null;
}

handleRequestEmailSent(response: RequestEmailResponse): void {
    this.activeEmailRequest = null;
    this.showUpdateSuccess(`Email sent successfully to ${response.to}.`);
}

 ///PJY 26 March 2026 - add outSource Roles
canEditRfiStage(): boolean {
    return !this.authService.isReadOnly()
      && this.authService.hasAnyRole(['Admin','OutSourceAdmin','OutsourcePM']);
}

canEditRfiPriority(): boolean {
    return !this.authService.isReadOnly();
}

getStageDisplay(stage: string | null): string {
  if (!stage) return 'Action Required';
  return stage;
}

getStageClass(stage: string | null): string {
  const display = this.getStageDisplay(stage);
  switch (display) {
    case 'Action Required': return 'stage-action';
    case 'Acknowledged':    return 'stage-ack';
    case 'In Progress':     return 'stage-prog';
    case 'Complete':        return 'stage-done';
    default:                return '';
  }
}

getStatusClass(status: string): string {
  switch (status) {
    case 'Open':     return 'status-open';
    case 'Answered': return 'status-answered';
    case 'Closed':   return 'status-closed';
    default:         return '';
  }
}

getPriorityClass(priority: string): string {
  switch (priority) {
    case 'High':   return 'priority-high';
    case 'Medium': return 'priority-medium';
    case 'Low':    return 'priority-low';
    default:       return 'priority-medium';
  }
}

getStageValue(displayValue: string): string | null {
  if (displayValue === 'Action Required') return null;
  return displayValue;
}

updateStatus(rfi: Request): void {
    const guid = rfi.requestGuid ? rfi.requestGuid.toString() : '';
    this.updatingStatus[guid] = true;
    this.requestService.updateRequestStatus(guid, rfi.status, localStorage.getItem('id') || '', rfi.number, rfi.projectNumber).subscribe({
      next: () => {
        this.showUpdateSuccess('Status updated successfully!');
        this.updatingStatus[guid] = false;
      },
      error: (err) => {
        console.error('Failed to update status:', err);
        this.uploadError = 'Failed to update status';
        this.updatingStatus[guid] = false;

        // Revert to previous status by reloading requests
        this.fetchRequests();
      }
    });
}

updateStage(rfi: Request, displayValue: string): void {
    if (!this.canEditRfiStage()) {
      this.uploadError = 'Only admin users can change request stages.';
      // Keep UI and data in sync by reloading the latest data
      this.fetchRequests();
      return;
    }

    const guid = rfi.requestGuid ? rfi.requestGuid.toString() : '';
    const stageValue = this.getStageValue(displayValue);
    this.updatingStage[guid] = true;
    rfi.stage = stageValue;
    this.requestService.updateRequestStage(guid, stageValue, localStorage.getItem('id') || '', rfi.number, rfi.projectNumber).subscribe({
      next: () => {
        this.showUpdateSuccess('Stage updated successfully!');
        this.updatingStage[guid] = false;
      },
      error: (err) => {
        console.error('Failed to update stage:', err);
        this.uploadError = 'Failed to update stage';
        this.updatingStage[guid] = false;

        // Revert by reloading requests
        this.fetchRequests();
      }
    });
}

updatePriority(rfi: Request): void {
    const guid = rfi.requestGuid ? rfi.requestGuid.toString() : '';
    this.updatingPriority[guid] = true;
    this.requestService.updateRequestPriority(guid, rfi.priority, localStorage.getItem('id') || '', rfi.number, rfi.projectNumber).subscribe({
      next: () => {
        this.showUpdateSuccess('Priority updated successfully!');
        this.updatingPriority[guid] = false;
      },
      error: (err) => {
        console.error('Failed to update priority:', err);
        this.uploadError = 'Failed to update priority';
        this.updatingPriority[guid] = false;
        this.fetchRequests();
      }
    });
}

private showUpdateSuccess(message: string): void {
    this.updateSuccessMessage = message;
    this.updateSuccess = true;

    setTimeout(() => {
      const successMessage = document.querySelector('.success-message');
      if (successMessage) {
        successMessage.classList.add('fade-out');

        setTimeout(() => {
          this.updateSuccess = false;
        }, 500);
      }
    }, 2500);
}


applyFilters() : void 
{
  this.saveFilters();
  this.fetchRequests();
}

filterByProject(projectNumber: number): void {
  this.projectNumber = projectNumber;
  this.selectedProjectService.setSelectedProject(projectNumber);
  this.fetchRequests();
}

getProjectSortLabel(): string {
  if (this.projectSortStep === 0 || this.projectSortStep > this.sortableProjectNumbers.length) return '⇅';
  return '#' + this.sortableProjectNumbers[this.projectSortStep - 1];
}

sortBy(column: 'number' | 'date' | 'files' | 'status' | 'stage' | 'priority' | 'revisions' | 'project') {
  if (column === 'project') {
    this.statusSortStep = 0;
    this.stageSortStep = 0;
    this.prioritySortStep = 0;
    this.projectSortStep++;
    if (this.projectSortStep > this.sortableProjectNumbers.length) {
      // cycled through all projects — reset
      this.projectSortStep = 0;
      this.sortColumn = 'project';
      this.sortDirection = 'asc';
    } else {
      this.sortColumn = 'project';
    }
  } else if (column === 'stage') {
    this.statusSortStep = 0;
    this.projectSortStep = 0;
    this.prioritySortStep = 0;
    this.stageSortStep++;
    if (this.stageSortStep > 4) {
      this.stageSortStep = 0;
      this.sortColumn = 'number';
      this.sortDirection = 'asc';
    } else {
      this.sortColumn = 'stage';
    }
  } else if (column === 'status') {
    this.stageSortStep = 0;
    this.projectSortStep = 0;
    this.prioritySortStep = 0;
    this.statusSortStep++;
    if (this.statusSortStep > 3) {
      this.statusSortStep = 0;
      this.sortColumn = 'number';
      this.sortDirection = 'asc';
    } else {
      this.sortColumn = 'status';
    }
  } else if (column === 'priority') {
    this.stageSortStep = 0;
    this.statusSortStep = 0;
    this.projectSortStep = 0;
    this.prioritySortStep++;
    if (this.prioritySortStep > 3) {
      this.prioritySortStep = 0;
      this.sortColumn = 'number';
      this.sortDirection = 'asc';
    } else {
      this.sortColumn = 'priority';
    }
  } else {
    this.stageSortStep = 0;
    this.statusSortStep = 0;
    this.prioritySortStep = 0;
    this.projectSortStep = 0;
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
  }
  this.sortRequests();
}


sortRequests() {
  const dir = this.sortDirection === 'asc' ? 1 : -1;
  this.requests.sort((a, b) => {
    // When advanced filter is "Action Required", always group Answered before Open
    if (this.filters.stage === 'Action Required' && this.sortColumn !== 'stage') {
      const aIsAnswered = a.status === 'Answered' ? 0 : 1;
      const bIsAnswered = b.status === 'Answered' ? 0 : 1;
      if (aIsAnswered !== bIsAnswered) return aIsAnswered - bIsAnswered;
    }

    if (this.sortColumn === 'project') {
      if (this.projectSortStep > 0 && this.projectSortStep <= this.sortableProjectNumbers.length) {
        // Focused mode: bring the focused project to top, rest sorted by project number
        const focused = this.sortableProjectNumbers[this.projectSortStep - 1];
        const aMatch = a.projectNumber === focused ? 0 : 1;
        const bMatch = b.projectNumber === focused ? 0 : 1;
        if (aMatch !== bMatch) return aMatch - bMatch;
        // within same group, sort by project number then request number
        if (a.projectNumber !== b.projectNumber) return a.projectNumber - b.projectNumber;
        return (parseInt(a.number, 10) || 0) - (parseInt(b.number, 10) || 0);
      }
      // Default project sort (no focus): sort by project number asc/desc
      const diff = (a.projectNumber - b.projectNumber) * dir;
      if (diff !== 0) return diff;
      return (parseInt(a.number, 10) || 0) - (parseInt(b.number, 10) || 0);
    } else if (this.sortColumn === 'number') {
      return ((parseInt(a.number, 10) || 0) - (parseInt(b.number, 10) || 0)) * dir;
    } else if (this.sortColumn === 'date') {
      const da = a.createdDate ? new Date(a.createdDate).getTime() : 0;
      const db = b.createdDate ? new Date(b.createdDate).getTime() : 0;
      return (da - db) * dir;
    } else if (this.sortColumn === 'status') {
      const statusLabels = ['Open', 'Answered', 'Closed'];
      const focused = statusLabels[this.statusSortStep - 1];
      const getScore = (r: Request) => {
        if (r.status === focused) return 0;
        const order: Record<string, number> = { 'Open': 1, 'Answered': 2, 'Closed': 3 };
        return order[r.status] ?? 4;
      };
      return getScore(a) - getScore(b);
    } else if (this.sortColumn === 'stage') {
      const stageLabels = ['Action Required', 'Acknowledged', 'In Progress', 'Complete'];
      const focused = stageLabels[this.stageSortStep - 1];
      const getScore = (r: Request) => {
        const guid = r.requestGuid.toString();
        const s = this.getStageDisplay(r.stage);
        if (focused === 'Action Required') {
          // Answered + Action Required first (score 0), then Open with responses (score 1), then rest
          if (r.status === 'Answered' && s === 'Action Required') return 0;
          if (r.status === 'Open' && !!this.hasAnyResponseMap[guid]) return 1;
          if (r.status === 'Answered') return 2;
          if (r.status === 'Open') return 3;
          return 4;
        }
        if (r.status !== 'Answered') return 3;
        if (s === focused) return 0;
        return 2;
      };
      const diff = getScore(a) - getScore(b);
      if (diff !== 0) return diff;
      // secondary: sort by request number within same score group
      return (parseInt(a.number, 10) || 0) - (parseInt(b.number, 10) || 0);
    } else if (this.sortColumn === 'priority') {
      const orders: Record<string, number>[] = [
        { 'High': 0, 'Medium': 1, 'Low': 2 },
        { 'Medium': 0, 'High': 1, 'Low': 2 },
        { 'Low': 0, 'Medium': 1, 'High': 2 },
      ];
      const order = orders[this.prioritySortStep - 1];
      const getScore = (r: Request) => order[r.priority] ?? 3;
      const diff = getScore(a) - getScore(b);
      if (diff !== 0) return diff;
      return (parseInt(a.number, 10) || 0) - (parseInt(b.number, 10) || 0);
    } else if (this.sortColumn === 'revisions') {
      const ra = this.revisionCountMap[a.requestGuid.toString()] || 0;
      const rb = this.revisionCountMap[b.requestGuid.toString()] || 0;
      return (ra - rb) * dir;
    } else {
      const fa = this.fileCountMap[a.requestGuid.toString()] || 0;
      const fb = this.fileCountMap[b.requestGuid.toString()] || 0;
      return (fa - fb) * dir;
    }
  });
}

}
